import React from 'react';
import { ScrollView } from 'react-native';
import FullPageSimulator from '../../FullPageSimulator';
import InputTextOverBtn from '../../../AuxiliaryComponent/MixComponent/InputTextOverBtn';
import { Android } from '../../../../../utils/DictionaryManagementUtils';

//= ========================================================================
const ReferenceEnterCustomReasonFP = ({
  globJSON,
  withSubCategory,
  simPlatform,
  subCategoryId,
  TopTitle,
  WithGrayBackground,
  inputText,
  headlineText,
  withPrimaryColor,
  slideshowRefs,
  withOutKeyboard,
  isLoan,
}) => {
  const heightScrollViewAndroid = withOutKeyboard ? 120 : 80;
  const heightScrollViewIos = withOutKeyboard ? 120 : 70;

  return (

    <FullPageSimulator
      globJSON={globJSON}
      slideshowRefs={slideshowRefs}
      simPlatform={simPlatform}
      headlineText={headlineText}
      keyboardType={!withOutKeyboard && 'lettersKeyboard'}
      TopTitle={TopTitle}
      WithGrayBackground={WithGrayBackground}
    >
      <ScrollView
        style={{
          height: simPlatform === Android ? heightScrollViewAndroid : heightScrollViewIos,
          width: 240,
          backgroundColor: globJSON.configurations.theme.colors.app_background_color,
        }}
        vertical
        pagingEnabled={false}
        showsVerticalScrollIndicator={false}
        scrollEnabled
      >
        <InputTextOverBtn
          globJSON={globJSON}
          inputText={inputText}
          subCategoryId={subCategoryId}
          simPlatform={simPlatform}
          whiteBackground
          withSubCategory={withSubCategory}
          withPrimaryColor={withPrimaryColor}
          marginTop={14}
          isLoan={isLoan}
        />
      </ScrollView>
    </FullPageSimulator>
  );
};

export default ReferenceEnterCustomReasonFP;
